import { Flows } from "@libs/acp/flows/types";

export const signinWithPasswordOnly = [
	Flows.SIGNIN,
	Flows.SIGNIN_CROSS,
	Flows.SIGNIN_CROSS_COMPLEX_PASSWORD,
	Flows.SIGNIN_CROSS_DISTINCT,
	Flows.SIGNIN_OLD_CP,
	Flows.SIGNIN_UNIFY_PASSWORD,
];
